import { render, staticRenderFns } from "./OrderProductStock.vue?vue&type=template&id=9002297c&scoped=true&"
import script from "./OrderProductStock.vue?vue&type=script&lang=js&"
export * from "./OrderProductStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9002297c",
  null
  
)

export default component.exports